<template>
	<v-app>
		<div class="wrap" :class="[detailStore.isDark ? 'darkmode' : '']">
			<headerLayout @click:mode-chg="mode"></headerLayout>
			<div class="container">
				<leftMenuLayout></leftMenuLayout>
				<div class="content">
					<NuxtPage/>
				</div>
			</div>
		</div>
	</v-app>
</template>

<script setup lang="ts">
import {onMounted, watch} from 'vue'
import headerLayout from '../components/header.vue'
import leftMenuLayout from '../components/leftMenu.vue'
import {useDetailStore} from '~/stores/detail'
import {useTheme} from 'vuetify'

const detailStore = useDetailStore()
const theme = useTheme()

// mode toggle 처리
const mode = (e: { value: boolean }) => {
	const isDark = !e.value
	detailStore.setIsDark(isDark)
	theme.global.name.value = isDark ? 'dark' : 'light'
	document.querySelector('.wrap')?.classList.toggle('darkmode', isDark)
}

onMounted(() => {
	const stored = sessionStorage.getItem('isDark')
	if (stored !== null) {
		const parsed = stored === 'true'
		detailStore.setIsDark(parsed)
		theme.global.name.value = parsed ? 'dark' : 'light'
		document.querySelector('.wrap')?.classList.toggle('darkmode', parsed)
	}
})

watch(() => detailStore.isDark, (newVal) => {
	sessionStorage.setItem('isDark', newVal.toString())
})
</script>

<style lang="scss" scoped>
</style>